/* eslint-disable jsx-a11y/anchor-is-valid */
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "@mui/material";
import moment from "moment";
import "moment/locale/pt-br";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../../../../providers/auth";
import { useFilters } from "../../../../../providers/filters";
import { useScheduleInfos } from "../../../../../providers/schedule";

import { IHealthyInsurance } from "../../../../../types/doctor";
import { IAgendamentoCard } from "./types";

import Modal from 'react-bootstrap/Modal';
import { usePartnerData } from "../../../../../providers/partnerData";
import LoginButton from "../../../../Elements/Buttons/LoginButton";
import { ReportModal } from "../ReportCard";

moment.locale("pt-br");

/**
 * Verifica se um agendamento deve ser bloqueado.
 * 
 * Bloqueia se:
 * - Já passou do horário atual, ou
 * - Faltam 30 minutos ou menos para o agendamento.
 */
export const checkBlockSchedule = (scheduleDate: string | Date): boolean => {
  const now = moment();
  const schedule = moment(scheduleDate).startOf("minute");

  const diffInMinutes = schedule.diff(now, "minutes");

  return schedule.isBefore(now) || diffInMinutes <= 30;
}

export const AgendamentoCard = ({
  modal,
  setModal,
  restriction,
}: IAgendamentoCard) => {
  const { partnerUrl } = usePartnerData();
  const navigate = useNavigate();
  const { token } = useAuth();
  const { resetFilters } = useFilters();

  const { scheduleInfos, clearScheduleInfos, saveScheduleInfosInLocalStorage } = useScheduleInfos();

  const { doctor, place, schedule } = scheduleInfos;

  const [scheduleType, setScheduleType] = useState<"video" | "presencial" | "">(
    schedule.agendas[0].tipo === 0
      ? "presencial"
      : schedule.agendas[0].tipo === 1
        ? "video"
        : ""
  );

  const [healtyInsurance, setHealtyInsurance] = useState<IHealthyInsurance>({
    id: 354,
    name: "Particular",
  });
  const [showRestrictions, setShowRestrictions] = useState<boolean>(
    restriction.length ? true : false
  );

  const [showReport, setShowReport] = useState<boolean>(false);
  const [report, setReport] = useState<string>("");

  const formatedData: string = schedule.data.split("T")[0] + "T" + schedule.agendas[0].timeStart + ":00";

  const timeToSchedule: string = moment(formatedData).startOf("minutes").fromNow();

  const shouldBlockSchedule = checkBlockSchedule(formatedData);

  //? 0 - Feminino, 1 - Masculino
  const doctorImage: string = doctor.image
    ? doctor.image
    : doctor.gender === 0
      ? "https://conectadoc.com.br/ImgMedico/Thumbs/ThumbFemale.jpg"
      : "https://conectadoc.com.br/ImgMedico/Thumbs/ThumbMale.jpg";

  const handleShowReportModal = () => {
    if (scheduleType === "video") {
      setShowReport(true);
    } else {
      handleConfirmSchedule();
    }
  };

  const handleConfirmSchedule = () => {
    if (!healtyInsurance || scheduleType.length === 0) {
      return;
    }
    resetFilters();

    scheduleInfos.scheduleDetails = {
      type: scheduleType,
      healtyInsurance,
      reportMessage: report,
    };

    scheduleInfos.isVideo = scheduleType === "video" ? true : false;

    saveScheduleInfosInLocalStorage();

    navigate(`/${partnerUrl}/pagamento`, { state: { appointment: undefined, scheduleData: scheduleInfos } });
  };

  const closeModal = () => {
    clearScheduleInfos();
    setModal(false);
  };

  useEffect(() => {
    if (scheduleType === "video") {
      setHealtyInsurance({
        id: 354,
        name: "Particular",
      });
    }
  }, [scheduleType]);

  return (
    <Modal
      show={modal}
      onHide={() => closeModal}
      backdrop="static"
      keyboard={false}
      className="text-body"
      centered
      scrollable
    >
      <div className="modal-header">
        <h5 className="modal-title">
          <i className="las la-calendar-alt me-3"></i>
          Agendamento de Consulta
        </h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => setModal(false)}
        ></button>
      </div>
      <div className="modal-body bg-light">
        {!showReport ? (
          <>
            <h6 className="text-muted text-uppercase small">
              Profissional:
            </h6>
            <div className="bg-white rounded-4 border p-3 pb-0 mb-4">
              <div className="row align-items-center">
                <div className="col col-auto pb-3 e-0">
                  <div className="img-wrap" style={{ width: 60 }}>
                    <a href="#">
                      <img alt={`${doctor.gender === 0 ? "Dra." : "Dr."} ${doctor.name}`} src={doctorImage} />
                    </a>
                  </div>
                </div>

                <div className="col-12 col-sm pb-3">
                  <h6 className="text-primary mb-1 small">
                    CRM: {doctor.crm}
                  </h6>
                  <h5 className="mb-1">
                    {doctor.gender === 0 ? "Dra." : "Dr."} {doctor.name}
                    <Tooltip title="Profissional Verificado">
                      <i
                        className="las la-check-circle text-primary ms-2"
                      ></i>
                    </Tooltip>
                  </h5>
                  <h6 className="mb-0">
                    {doctor.specialty.length
                      ? doctor.specialty[0].name
                      : ""}
                  </h6>
                </div>
              </div>
            </div>

            <h6 className="text-muted text-uppercase small">
              Data e hora da consulta:
            </h6>
            <div className="bg-white rounded-4 border p-3 pb-0 mb-4">
              <h5 className="text-center mb-3">
                {moment(new Date(schedule.data)).format("L")} -{" "}
                <span className="text-primary">
                  {schedule.agendas[0].timeStart}
                </span>
              </h5>
            </div>

            <div>
              {shouldBlockSchedule ? (
                <>
                  <h6 className="text-muted text-uppercase small">
                    Restrições e Observações:
                  </h6>
                  <div
                    style={{ maxHeight: "150px", overflowY: "auto" }}
                    className="alert alert-danger rounded-4 p-3 pb-3 mb-4"
                  >
                    <h6 className="mb-0 text-uppercase small text-center">
                      Agendamento só é permitido 30 minutos antes do horário disponível
                    </h6>
                  </div>
                </>
              ) : (
                <>
                  {restriction.length &&
                    showRestrictions &&
                    !shouldBlockSchedule &&
                    !showReport ? (
                    <>
                      <h6 className="text-muted text-uppercase small">
                        Restrições e Observações:
                      </h6>
                      <div className="alert alert-warning rounded-4 p-3 pb-3 mb-4">
                        <h6
                          style={{
                            whiteSpace: "pre-wrap",
                          }}
                          className="mb-0 text-uppercase small text-center"
                        >
                          {restriction}
                        </h6>
                      </div>
                    </>
                  ) : (
                    <>
                      <h6 className="text-muted text-uppercase small">
                        Tipo de consulta:
                      </h6>
                      <ul className="list-group rounded-4 mb-4">
                        {/* //! ONLINE */}
                        {schedule.agendas[0].tipo === 1 && (
                          <li className="list-group-item list-group-item-action">
                            <label className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                value={scheduleType}
                                defaultChecked
                                name="tipoConsulta"
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  marginTop: 0,
                                }}
                              />
                              <div className="form-check-label">
                                <div className="row align-items-center g-0">
                                  <div className="col col-auto">
                                    <i className="las la-video display-5 fw-bold opacity-50 me-3"></i>
                                  </div>
                                  <div className="col">
                                    <h6 className="mb-0 fw-bold">
                                      Vídeo
                                    </h6>
                                    <small>
                                      Valor:{" "}
                                      <span className="fw-bold">
                                        R$ {place.telePrice.toFixed(2)}
                                      </span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </label>
                          </li>
                        )}
                        {/* //! PRESENCIAL */}
                        {schedule.agendas[0].tipo === 0 && (
                          <li className="list-group-item list-group-item-action">
                            <label className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                value={scheduleType}
                                defaultChecked
                                name="tipoConsulta"
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  marginTop: 0,
                                }}
                              />
                              <div className="form-check-label">
                                <div className="row align-items-center g-0">
                                  <div className="col col-auto">
                                    <i className="las la-hospital display-5 fw-bold opacity-50 me-3"></i>
                                  </div>
                                  <div className="col">
                                    <h6 className="mb-0 fw-bold">
                                      Presencial
                                    </h6>
                                    <p className="mb-0 fw-bold small opacity-75">
                                      {place && place.name}
                                    </p>
                                    <p className="small opacity-75 mb-0">
                                      <small>
                                        {place.addressName},{" "}
                                        {place.number}
                                        <br />
                                        CEP: {place.cep}{" "}
                                        {place.neighborhood} -{" "}
                                        {place.city}/{place.state}
                                      </small>
                                    </p>
                                    {place.price > 0 &&
                                      healtyInsurance.name ===
                                      "Particular" && (
                                        <small
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          Valor:{" "}
                                          <span
                                            className="fw-bold"
                                            style={{ marginLeft: "5px" }}
                                          >
                                            R$ {place.price.toFixed(2)}
                                          </span>
                                          <Tooltip title="Apenas para consultas particulares" >
                                            <InfoOutlinedIcon
                                              fontSize="small"
                                              className="las la-info-circle ms-2"
                                            />
                                          </Tooltip>
                                        </small>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </label>
                          </li>
                        )}

                        {/* //! PRESENCIAL E ONLINE */}
                        {schedule.agendas[0].tipo === 2 && (
                          <>
                            <li className="list-group-item list-group-item-action">
                              <label className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  value={scheduleType}
                                  onChange={() => {
                                    setScheduleType("video");
                                    setHealtyInsurance(
                                      doctor.healthInsurance.find(
                                        (elm) => elm.name === "Particular"
                                      ) || {
                                        id: 354,
                                        name: "Particular",
                                      }
                                    );
                                  }}
                                  name="tipoConsulta"
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    marginTop: 0,
                                  }}
                                />
                                <div className="form-check-label">
                                  <div className="row align-items-center g-0">
                                    <div className="col col-auto">
                                      <i className="las la-video display-5 fw-bold opacity-50 me-3"></i>
                                    </div>
                                    <div className="col">
                                      <h6 className="mb-0 fw-bold">
                                        Vídeo
                                      </h6>
                                      {place.telePrice > 0 && (
                                        <small>
                                          Valor:{" "}
                                          <span className="fw-bold">
                                            R${" "}
                                            {place.telePrice.toFixed(2)}
                                          </span>
                                        </small>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </label>
                            </li>
                            <li className="list-group-item list-group-item-action">
                              <label className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  value={scheduleType}
                                  onChange={() =>
                                    setScheduleType("presencial")
                                  }
                                  name="tipoConsulta"
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    marginTop: 0,
                                  }}
                                />
                                <div className="form-check-label">
                                  <div className="row align-items-center g-0">
                                    <div className="col col-auto">
                                      <i className="las la-hospital display-5 fw-bold opacity-50 me-3"></i>
                                    </div>
                                    <div className="col">
                                      <h6 className="mb-0 fw-bold">
                                        Presencial
                                      </h6>
                                      <p className="mb-0 fw-bold small opacity-75">
                                        {place && place.name}
                                      </p>
                                      <p className="small opacity-75 mb-0">
                                        <small>
                                          {place.addressName},{" "}
                                          {place.number}
                                          <br />
                                          CEP: {place.cep}{" "}
                                          {place.neighborhood} -{" "}
                                          {place.city}/{place.state}
                                        </small>
                                      </p>
                                      {place.price > 0 &&
                                        healtyInsurance.name ===
                                        "Particular" && (
                                          <small
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            Valor:{" "}
                                            <span
                                              className="fw-bold"
                                              style={{
                                                marginLeft: "5px",
                                              }}
                                            >
                                              R$ {place.price.toFixed(2)}
                                            </span>
                                            <Tooltip
                                              style={{
                                                marginLeft: "5px",
                                              }}
                                              title="Apenas para consultas particulares"
                                            >
                                              <InfoOutlinedIcon
                                                fontSize="small"
                                                className="las la-info-circle"
                                              />
                                            </Tooltip>
                                          </small>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </label>
                            </li>
                          </>
                        )}
                      </ul>
                      <div className={`${scheduleType !== "presencial" && 'd-none'}`}>
                        <h6 className="text-muted text-uppercase small">
                          Convênio / Particular:
                        </h6>
                        <select
                          disabled={scheduleType !== "presencial"}
                          onChange={(e) =>
                            setHealtyInsurance(
                              doctor.healthInsurance.find(
                                (elm) => elm.name === e.target.value
                              ) || { id: null, name: e.target.value }
                            )
                          }
                          className="form-select"
                          value={
                            scheduleType === "video"
                              ? "Particular"
                              : healtyInsurance.name
                          }
                        >
                          <option value="" disabled>
                            Selecione o Convênio
                          </option>
                          {place.healthInsurance &&
                            place.healthInsurance.map((elm, i) => (
                              <option key={i} value={String(elm.name)}>
                                {elm.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </>
        ) : (
          <>
            <ReportModal value={report} setValue={setReport} />
          </>
        )}
      </div>
      <div className="modal-footer justify-content-center">
        {showRestrictions && !shouldBlockSchedule ? (
          <>
            <p className="opacity-50 small">Ao confirmar, declaro que li as restrições e estou ciente de que, em caso de divergências, a consulta pode não ser realizada e poderá ser cobrado o valor da consulta particular.</p>
            <button
              onClick={() => setShowRestrictions(false)}
              className="btn btn-success fw-semibold"
            >
              <i className="las la-check me-2"></i>Confirmar
            </button>
          </>
        ) : (
          <>
            {shouldBlockSchedule ? (
              <>
                <button
                  onClick={closeModal}
                  className="btn btn-outline-danger"
                >
                  Fechar
                </button>
              </>
            ) : (
              <>
                {token && (
                  <>
                    {showReport ? (
                      <button
                        disabled={scheduleType.length <= 0}
                        onClick={handleConfirmSchedule}
                        className="btn btn-primary"
                      >
                        Prosseguir <i className="las la-arrow-right ms-2"></i>
                      </button>
                    ) : (
                      <button
                        disabled={!healtyInsurance || scheduleType.length <= 0}
                        onClick={handleShowReportModal}
                        className="btn btn-primary"
                      >
                        Prosseguir <i className="las la-arrow-right ms-2"></i>
                      </button>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
        {!token && !showRestrictions && (
          <>
            <p className="opacity-50 small">Crie sua conta ou faça seu login para agendar.</p>
            <div className="d-flex gap-3 justify-content-center">
              <LoginButton className="btn-primary">Fazer login</LoginButton>
              <a
                href={`/${partnerUrl}/user`}
                className="btn btn-success text-uppercase fw-bold"
              >
                Criar Conta
              </a>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};
